import { colorPalette } from '../../../colorPalette';
export const drawer = (theme) => ({
    zIndex: theme.zIndex.appBar + 400,
    '.MuiPaper-root': {
        borderRadius: '16px 16px 0 0',
    }
});
export const title = {
    textAlign: 'center'
};
export const menuItemStyle = {
    borderTop: `1px solid ${colorPalette.gray200}`,
    padding: '16px',
    '& svg': {
        marginRight: '8px'
    },
};
